export default {
  LOG_LEVEL: {
    DEBUG: 'debug',
    INFO: 'info',
    WARN: 'warn',
    ERROR: 'error',
    METRICS: 'metrics',
    GRAPH: 'graph',
    BAM: 'bam',
  },
};




// WEBPACK FOOTER //
// ./src/logger/Const.js